import restCrudActions from "../../../np-crud/store/restCrudActions";
import { getAxiosInstance } from "../../../np-rest/rest";
import { snackActions } from "../../../sc-utilities/SnackBar";

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: "mobile-erase-station",
    pluginName: "MOBILE_ERASE_STATION",
    entityName: "MOBILE_ERASE_STATION",
    fetchSuccessMessage: "",
    loadSuccessMessage: "",
    createFailedUseBackendMessage: true,
    createSuccessUseBackendMessage: true,
    deleteFailedUseBackendMessage: true,
    editFailedUseBackendMessage: true,
    bulkDeleteFailedUseBackendMessage: true,
});

// Fetch mobile station action creators
export const fetchMobileEraseStationInit = () => {
    return crudActions.fetchInit();
};
export const fetchMobileEraseStationStart = () => {
    return crudActions.fetchStart();
};
export const fetchMobileEraseStationSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchMobileEraseStationFail = () => {
    return crudActions.fetchFail();
};

export const fetchMobileEraseStationsCount = (filterData) => {
    const rest = getAxiosInstance();

    return async (dispatch) => {
        dispatch(fetchMobileEraseStationInit());
        try {
            let countRes = await rest.post("/mobile-erase-station/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchMobileEraseStationSuccess(0, []));
                }
                return countRes.data.result.data;
            }
            dispatch(fetchMobileEraseStationFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data
                        ? countRes.data.message
                        : "Cannot fetch mobile station data."
                    }`,
                options: {
                    variant: "warning",
                },
            });
            return 0;
        } catch (error) {
            dispatch(fetchMobileEraseStationFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch mobile station data."
                    }`,
                options: {
                    variant: "error",
                },
            });
            return 0;
        }
    };
};

export const fetchMobileEraseStations = (filterData) => {
    const rest = getAxiosInstance();

    return async (dispatch) => {
        dispatch(fetchMobileEraseStationInit());
        try {
            let listRes = await rest.post("/mobile-erase-station/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(
                    fetchMobileEraseStationFail(
                        filterData.count,
                        listRes.data.result.data
                    )
                );
                return listRes.data.result.data;
            }
            dispatch(fetchMobileEraseStationSuccess());
            return [];
        } catch (error) {
            dispatch(fetchMobileEraseStationFail());
            return [];
        }
    };
};

// Bulk delete mobile station
export const bulkDeleteMobileEraseStationsInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteMobileEraseStationsStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteMobileEraseStationsSuccess = (result) => {
    return crudActions.bulkDeleteSuccess(result);
};
export const bulkDeleteMobileEraseStationsFail = (error) => {
    return crudActions.bulkDeleteFail(error);
};

export const bulkDeleteMobileEraseStations = (params) => {
    const rest = getAxiosInstance();
    return async (dispatch) => {
        dispatch(bulkDeleteMobileEraseStationsStart());
        try {
            let res = await rest.post("/mobile-erase-station/bulk-delete", params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteMobileEraseStationsSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted mobile stations.`,
                    options: {
                        variant: "success",
                    },
                });
                return;
            }
            dispatch(
                bulkDeleteMobileEraseStationsFail({
                    message: `${res && res.data
                            ? res.data.message
                            : res && res.message
                                ? res.message
                                : "Cannot bulk delete mobile stations."
                        }`,
                })
            );
            snackActions.snackBar({
                message: `${res && res.data
                        ? res.data.message
                        : res && res.message
                            ? res.message
                            : "Cannot bulk delete mobile stations."
                    }`,
                options: {
                    variant: "warning",
                },
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteMobileEraseStationsFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: "error",
                },
            });
            return null;
        }
    };
};

// Load mobile station action creators
export const loadMobileEraseStationInit = () => {
    return crudActions.loadInit();
};
export const loadMobileEraseStationStart = () => {
    return crudActions.loadStart();
};
export const loadMobileEraseStationSuccess = (loadedMobileEraseStation) => {
    return crudActions.loadSuccess(loadedMobileEraseStation);
};
export const loadMobileEraseStationFail = (error) => {
    return crudActions.loadFail(error);
};
export const loadMobileEraseStation = (loadParams, options = {}) => {
    return async (dispatch) => {
        await crudActions.load(dispatch, loadParams, options);
    };
};

// Edit action creators
export const editMobileEraseStationInit = () => {
    return crudActions.editInit();
};
export const editMobileEraseStationStart = () => {
    return crudActions.editStart();
};
export const editMobileEraseStationSuccess = (editedMobileEraseStation) => {
    return crudActions.editSuccess(editedMobileEraseStation);
};
export const editMobileEraseStationFail = (error) => {
    return crudActions.editFail(error);
};
export const editMobileEraseStation = (data) => {
    return async (dispatch) => {
        await crudActions.edit(dispatch, data);
    };
};


export const revokeMobileEraseStation = (data) => {
    const rest = getAxiosInstance();

    return async dispatch => {
        try {
            const res = await rest.post("/mobile-erase-station/revoke", data);
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })

                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot revoke mobile station."}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    }
}